import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import '../styles.css';

function Excuses() {
  const navigate = useNavigate();
  const [selectedExcuse, setSelectedExcuse] = useState('');
  const [recentExcuses, setRecentExcuses] = useState([]);

  const handleClose = () => navigate('/');

  const excuses = {
  "I was slower than I should be": [
    "My tire pressure was 0.5 psi too low",
    "I didn't have time to get an alignment",
    "I'm not taking it too seriously, I just want to have fun",
    "I was conserving fuel for the victory lap",
    "I'm too heavy",
    "There was a bad gust of wind",
    "My tires were cold",
    "These tires are done",
    "I was daydreaming about my podium speech",
    "The track was uphill both ways",
    "I was practicing for the slow-motion replay",
    "The track is slow today"
  ],
  "I blocked someone by accident": [
    "I was distracted by a squirrel on the track",
    "My mirrors were fogged up from the excitement",
    "I thought it was a ghost car",
    "The steering wheel slipped in my sweaty hands",
    "I was practicing my dance moves while driving",
    "My car has a mind of its own",
    "If you were faster you would have passed me",
    "It's not my fault you didn't have the balls to pass",
    "My GPS told me to protect my line",
    "I was trying to set a new personal best for mirror checks",
    "A bee flew into the cockpit and I panicked"
  ],
  "My car made less power than I thought it would": [
    "That was on low boost",
    "My car is solar-powered and it was cloudy",
    "It's just the base tune",
    "I'm breaking it in gently",
    "The air was too humid for the engine",
    "I forgot to feed the hamsters in the engine",
    "My turbo was napping",
    "The fuel was decaf instead of high-octane"
  ],
    "I spun out": [
    "The Earth rotated too fast",
    "My tires were allergic to the track",
    "I was doing a victory donut early",
    "The car slipped on a banana peel",
    "Wind gust from a passing bird",
    "The setup is shit, car is undriveable",
    "There was oil down",
    "I was practicing my 360-degree camera skills",
    "I sent it too hard",
    "I hit the drift button by mistake"
  ],
  "I crashed into something": [
    "The track moved",
    "Gravity was stronger today",
    "My car decided to hug the wall",
    "I was testing aerodynamics",
    "The barrier was in the wrong place",
    "My brakes were on strike",
    "The corner was too tight",
    "The wall looked lonely and needed company",
    "My car mistook the barrier for a finish line",
    "I was practicing for the demolition derby"
  ],
  "I crashed into someone": [
    "You shouldn't have been there",
    "Rubbin's racin'",
    "I was practicing telepathy",
    "My car has auto-pilot issues",
    "I thought it was a mirror image",
    "The other car was invisible",
    "We were playing tag",
    "I was trying to draft but got too close",
    "My car thought it was a bumper car race",
    "I misjudged the size of my ego",
    "Our cars were just sharing a friendly tap"
  ]

  };

  const generateExcuse = (category) => {
    const categoryExcuses = excuses[category].filter(excuse => !recentExcuses.includes(excuse));
    let randomExcuse;
    if (categoryExcuses.length === 0) {
      // If all excuses in category are recent, pick from all (shouldn't happen with 6+ excuses)
      randomExcuse = excuses[category][Math.floor(Math.random() * excuses[category].length)];
    } else {
      randomExcuse = categoryExcuses[Math.floor(Math.random() * categoryExcuses.length)];
    }
    setSelectedExcuse(randomExcuse);
    setRecentExcuses(prev => [randomExcuse, ...prev.slice(0, 2)]);
  };

  return (
    <div>
      <Header />
      <div className="page-title">
        <h1>Excuse Generator</h1>
        <button onClick={handleClose} className="close-button">✕</button>
      </div>
      <div className="main-container">
        <div className="main-section">
          <div className="inputs-container">
            <p className="excuse-text">{selectedExcuse || 'Click a category to generate a very valid excuse.'}</p>
          </div>
          <div className="excuse-categories">
            {Object.keys(excuses).map(category => (
              <div
                key={category}
                className="excuse-card"
                onClick={() => generateExcuse(category)}
              >
                {category}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Excuses;